import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/lib/firebase";
import { useAuth } from "@/store/auth";
import { auth } from "@/lib/firebase";
import { useNavigate } from "react-router-dom";

import { plainError } from "@/lib/plainError";
/**
 * 최초 관리자 부트스트랩.
 * BOOTSTRAP_ADMIN_EMAILS 에 포함된 이메일만 자기 자신을 admin으로 승격 가능.
 * 이후 Firestore Auth에서 다른 사용자를 운전자/관리자로 지정.
 */
export default function Bootstrap() {
  const { user, role, signOut } = useAuth();
  const [log, setLog] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const makeMeAdmin = async () => {
    if (!user) return;
    setLoading(true);
    setLog("요청 중…");
    try {
      const fn = httpsCallable(functions, "setUserRole");
      const res = await fn({
        uid: user.uid,
        role: "admin",
        displayName: user.displayName || user.email,
      });
      setLog("✅ 완료. 권한을 새로 받는 중…");
      await auth.currentUser?.getIdToken(true);
      setTimeout(() => {
        setLog("✨ 관리자 권한 부여 완료! 다시 로그인하면 관리자 메뉴가 활성화됩니다.");
        signOut();
      }, 1000);
    } catch (e: any) {
      setLog(`❌ ${plainError(e)}`);
    } finally {
      setLoading(false);
    }
  };

  const makeMeDriver = async () => {
    if (!user) return;
    setLoading(true);
    setLog("요청 중…");
    try {
      const fn = httpsCallable(functions, "setUserRole");
      await fn({
        uid: user.uid,
        role: "driver",
        displayName: user.displayName || user.email,
      });
      setLog("✅ 기사 권한 부여 완료. 다시 로그인하면 적용됩니다.");
      await auth.currentUser?.getIdToken(true);
      setTimeout(() => signOut(), 1000);
    } catch (e: any) {
      setLog(`❌ ${plainError(e)}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto space-y-4">
      <h1 className="text-xl font-bold">🔐 권한 부여</h1>
      <div className="card p-4 text-sm">
        <div>현재 로그인: <strong>{user?.email}</strong></div>
        <div>계정 번호: <code className="text-xs">{user?.uid}</code></div>
        <div>현재 역할: <strong>{role || "없음"}</strong></div>
      </div>

      <div className="card p-4 space-y-3">
        <p className="text-sm text-slate-600">
          최초 세팅 시 본인을 <strong>관리자</strong>로 지정하세요. (<code>functions/.env</code> 의 <code>BOOTSTRAP_ADMIN_EMAILS</code>에 등록된 이메일만 가능)
        </p>
        <div className="flex gap-2">
          <button className="btn-primary flex-1" disabled={loading} onClick={makeMeAdmin}>
            나를 관리자(admin)로 지정
          </button>
          <button className="btn-secondary flex-1" disabled={loading} onClick={makeMeDriver}>
            나를 기사(driver)로 지정
          </button>
        </div>
      </div>

      <div className="card p-4 text-xs font-mono whitespace-pre-wrap min-h-[60px]">{log}</div>

      <div className="flex items-center gap-3">
        <button className="btn-ghost text-sm" onClick={() => navigate("/")}>홈으로</button>
        <button className="btn-ghost text-sm text-milk-700" onClick={() => navigate("/onboarding")}>
          🏢 새 업체를 시작하시나요? — 업체 만들기
        </button>
      </div>
    </div>
  );
}
